import React from 'react';
import PropTypes from 'prop-types';

import SidePanelControl from './SidePanelControl.js';

import './SidePanelControls.scss';

class SidePanelControls extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleControlClick = this.handleControlClick.bind(this);
  }

  handleControlClick(icon) {
    this.props.setActiveitem(icon.id);
    icon.onClick && icon.onClick(icon.id);
  }

  renderGroupElements(group) {
    return this.props.controls
      .filter(i => i.group === group)
      .map(i => (
        <SidePanelControl
          key={i.id}
          icon={i}
          isActive={i.id === this.props.activeItemId}
          onClick={this.handleControlClick}
          disabled={i.disabled}
        />
      ));
  }

  renderGroups() {
    const groups = this.props.controls
      .map(i => i.group)
      .filter((item, index, self) => self.indexOf(item) === index);

    return groups.map(group => (
      <div className="SidePanel__control-group" key={group}>
        {this.renderGroupElements(group)}
      </div>
    ));
  }

  render() {
    return <div className="SidePanel__bar">{this.renderGroups()}</div>;
  }
}

SidePanelControls.propTypes = {
  setActiveitem: PropTypes.func.isRequired,
  activeItemId: PropTypes.string,
  controls: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      group: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      label: PropTypes.string.isRequired
    })
  )
};

export default SidePanelControls;
